const CustomLegend = (props) => {
    const { payload } = props;
  
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center", 
          alignItems: "center",
          gap: "20px", 
          marginTop: "10px",
        }}
      >
        {payload.map((entry, index) => (
          <div key={`legend-${index}`} style={{ display: "flex", alignItems: "center" }}>
          
            <div
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                backgroundColor: entry.color,
                marginRight: "6px",
              }}
            ></div>
            <span style={{ color: "#757575", fontSize: "14px", fontWeight: "500" }}>
              {entry.value}
            </span>
          </div>
        ))}
      </div>
    );
  };
  
  export default CustomLegend;
  